import { Colors } from "@/components/common";

const sampleStatuses = {
  Pending: 1,
  InProcess: 2,
  Completed: 3,
  Cancelled: 4,
  Substituted:5
};

const getSampleStatusColor = (sampleStatusId)=>{
  switch (sampleStatusId) {
    case sampleStatuses.Pending:
      return Colors.YELLOW;
    case sampleStatuses.InProcess:
      return Colors.ORANGE;
    case sampleStatuses.Completed:
      return Colors.GREEN_LIGHT;
    case sampleStatuses.Cancelled:
      return Colors.BROWN;
    case sampleStatuses.Substituted:
      return Colors.VIOLET;
    default:
      return '';
  }
}

export { sampleStatuses, getSampleStatusColor };
